import { Stack } from "@mui/material";
import AnimationController from "../../../components/AnimationController";
import { SchoolPageFirstContent, SchoolPageSecondContent, SchoolPageThirdContent, SchoolPageForthContent, SchoolPageFifthContent, SchoolSixthContent, SchoolSeventhContent, VicContent } from "../components";
import { useEffect } from "react";

const VicSchoolPage = () => {

    useEffect(() => {
        localStorage.setItem('homeState', 'VIC');
    }, [])

    return (
        <>
            <Stack className={"page_stack space_for_header"}>
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolPageFirstContent loadedAnimation={alreadyLoaded} />
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolPageSecondContent loadedAnimation={alreadyLoaded}/>
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolPageFifthContent loadedAnimation={alreadyLoaded} />
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolSixthContent loadedAnimation={alreadyLoaded}/>
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolPageThirdContent loadedAnimation={alreadyLoaded} />
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <VicContent loadedAnimation={alreadyLoaded} />
                    )}
                />

                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolPageForthContent loadedAnimation={alreadyLoaded} />
                    )}
                />
                <AnimationController
                    render={(alreadyLoaded: boolean) => (
                        <SchoolSeventhContent loadedAnimation={alreadyLoaded} />
                    )}
                />
            </Stack>
        </>
    )
};

export default VicSchoolPage;